import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConnections,
  defaultConstruction,
  defaultDescription,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentStoreSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  objectNumbers: defaultObjectNumbers,
  basicInfo: {
    mainFloorSpace: validationRules.mainFloorSpaceRequired,
    separableSpace: validationRules.separableSpace,
    totalFloorSpace: validationRules.totalFloorSpaceOptional,
    price: usePurchasePriceOnRequestCondition,
    courtage: validationRules.courtage,
    courtageNote: validationRules.courtageNote,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  otherFacilities: {
    frontWindowLength: validationRules.frontWindowLength,
    floorLoad: validationRules.floorLoad,
    totalFloorsNumber: validationRules.totalFloors,
    goodsLiftLoad: validationRules.loadLiftingValue,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  connections: defaultConnections,
  construction: defaultConstruction,
  apiSearchData: defaultApiSearchData,
}
